export default function setUrlParameter(name, value) {
  if (
    typeof window.URLSearchParams === "function" && // will not work for IE
    typeof name === "string" &&
    name !== "" &&
    value
  ) {
    const urlParams = new URLSearchParams(window.location.search);

    urlParams.set(name, value);
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${urlParams}`
    );
  }
}
